import * as React from "react";
import { IComponentItem, IPanelInfo, IUserInfo } from "./models";

export interface AppContextProps {
    params?: any;
    path: string;
    sidebarCollapsed: boolean;
    blockLayout: boolean;
    blockTitle?: string;
    getPanelInfo: () => IPanelInfo;
    getMenuItems: () => IComponentItem[];
    getUserInfo: () => IUserInfo | null | undefined;
    setInfo: (menuItems: IComponentItem[], userInfo?: IUserInfo | null) => void;
    setSidebarCollapsed: (collapsed: boolean) => void;
    setPanelInfo: (panelInfo: IPanelInfo) => void;
    setBlockLayout: (blockLayout: boolean, blockTitle?: string) => void;
}

const AppContext = React.createContext<AppContextProps>({
    path: "/",
    sidebarCollapsed: false,
    blockLayout: false,
    getMenuItems: () => [],
    setInfo: () => { },
    getUserInfo: () => null,
    setSidebarCollapsed: () => { },
    getPanelInfo: () => {
        return { data: [] }
    },
    setPanelInfo: () => { },
    setBlockLayout: () => { },
});

export default AppContext;